<template>
    <main :class="category.id===2||category.id===33||category.id===9||category.id===29||category.id===21||category.id===30||category.id===15?'main_lanches':'main'" :id="category.id===2||category.id===33||category.id===9||category.id===29||category.id===21||category.id===30||category.id===15?'main_lanches':'main'">
        <div class="main_top_line">
            <div class="container">
                <div class="top_line_column">
                    <div class="m_tl_text">
                        <h1>Получи 100 рублей на телефон при любом заказе</h1>
                        <router-link tag="span" class="link" to="/rules">Пользовательское соглашение</router-link>
                    </div>
                    <div class="m_tl_icons">
                        <a href="#"><div class="icon icon1"></div></a>
                        <a href="#"><div class="icon icon2"></div></a>
                        <a href="#"><div class="icon icon3"></div></a>
                        <a href="#"><div class="icon icon4"></div></a>
                    </div>
                    <div class="m_tl_text">
                        <h1>Получи 200 рублей за регистрацию на бонусный счёт</h1>
                    </div>
                    <button class="green_btn" @click="showModal('register')">Получить</button>

                </div>
            </div>
        </div>

        <section class="section_a">
            <div class="container">
                <aside class="order_crytery">
                    <div class="order_crytery_title">
                        <h3>Критерии</h3>
                        <button type="button" class="choice_toggle" id="restaurant_toggle"></button>
                    </div>
                    <div class="order_crytery_inner" id="restaurant_crytery_inner" v-if="category.id !== 9&&category.id !== 29&&category.id !== 21&&category.id !== 30&&category.id !== 15">
                        <div class="meals">
                            <h3>Блюда</h3>
                            <div class="chack_group">
                                <label class="check_label" v-for="categorys in categories" :key="categorys.id">
                                    <router-link tag="input" :to="'/product/' + categorys.id" type="checkbox" name="choose" :checked="categorys.id === category.id ? true:false" />
                                    {{categorys.name}}
                                    <span> </span>
                                    <div class="dish_subcategory_one" v-if="categorys.id === category.id">
                                        <div class="subcategoryOne_check_box" v-if="additives_temp[additive.id]" v-for="additive in categorys.additives" :key="additive.id">
                                            <label class="check_label">
                                                <input type="checkbox" v-model="filter.additives[additive.id]" :value="additive.id" name="choose">
                                                {{additive.name}}
                                                <span> </span>
                                            </label>
                                            <div class="dish_subcategory_two" v-if="filter.additives[additive.id]">
                                                <label class="check_label" v-if="ingredients_temp[ingredient.id]" v-for="ingredient in additive.ingredients" :key="ingredient.id">
                                                    <input type="checkbox" v-model="filter.ingredients[ingredient.id]" :value="ingredient.id" name="choose">
                                                    {{ingredient.name}}
                                                    <span> </span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </label>
                            </div>

                        </div>
                        <div class="min_amount">
                            <h3>Минимальная сумма заказа</h3>
                            <div class="range_value">
                                <p id="display_range_value_2">{{price}}</p>
                            </div>
                            <div class="change_range">
                                <input type="range" id="min_amount_range_2" :min="priceMin" v-model="price" :max="priceMax" name="min_amount_range">
                            </div>

                        </div>
                        <div class="ordering_criteria">
                            <h3>Критерии заказа</h3>
                            <div class="chack_group">
                                <label class="check_label" v-for="(method, id) in methods" :key="id">
                                    <input type="checkbox" v-model="filter.methods[id]" :value="id" name="choose">
                                    {{method}}
                                    <span> </span>
                                    <span v-if="id === 4" :class="[auth.user? 'login header-login logged' : 'login header-login']"><a style="color: #56d023;text-decoration: underline;margin-top: 0px;margin-right: 0px;"> только авторизованным гостям</a></span>
                                </label>

                            </div>

                        </div>
                    </div>

                    <div class="order_crytery_inner" id="restaurant_crytery_inner" v-else>
                        <div class="meals">
                            <h3>Блюда</h3>
                            <div class="chack_group">
                                <label class="check_label" v-for="(kitchen, id) in kitchens" :key="id">
                                    <input type="checkbox" v-model="filter.categories[id]" :value="id" name="choose">
                                    {{kitchen}}
                                    <span> </span>
                                </label>
                            </div>

                        </div>
                        <div class="min_amount">
                            <h3>Минимальная сумма заказа</h3>
                            <div class="range_value">
                                <p id="display_range_value_2">{{price}}</p>
                            </div>
                            <div class="change_range">
                                <input type="range" id="min_amount_range_2" :min="priceMin" :max="priceMax" :step="step" :value="price" name="min_amount_range">
                            </div>

                        </div>
                        <div class="ordering_criteria">
                            <h3>Критерии заказа</h3>
                            <div class="chack_group">
                                <label class="check_label" v-for="(method, id) in methods" :key="id">
                                    <input type="checkbox" v-model="filter.methods[id]" :value="id" name="choose">
                                    {{method}}
                                    <span> </span>
                                    <span v-if="id === 4" :class="[auth.user? 'login header-login logged' : 'login header-login']"><a style="color: #56d023;text-decoration: underline;margin-top: 0px;margin-right: 0px;"> только авторизованным гостям</a></span>
                                </label>

                            </div>

                        </div>

                    </div>
                </aside>

                <!-- adding sidebar from separate html file -->
                <!-- <link rel="import" href="order_crytery.html">
                <script>
                    var dist = document.querySelector('.section_a .container')
                    var doc = document.querySelectorAll('link[rel="import"]');
                    for(i of doc) {
                    var cool = i.import;
                    var go = cool.querySelector('.order_crytery');
                    dist.appendChild(go.cloneNode(true));
                    }
                </script> -->
                <!-- adding sidebar from separate html file -->
              <div class="products_box">
                <div class="create_wok_wrapper" v-if="category.id === 2">
                  <div class="create_wok_wrapper_title" v-if="categories[2]&& categories[2].additives[124]&& categories[2].additives[125]">
                    <h3 class="create_wok_title">Создать свою пиццу</h3>
                    <button type="button" class="choice_toggle" id="constructor_toggle"></button>
                  </div>
                  <div class="create_wok" v-if="categories[2]&& categories[2].additives[124]&& categories[2].additives[125]">
                    <div class="foundation">
                      <div class="logo">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/wok/wok_logo.png" alt="wok_logo">
                      </div>
                      <div class="foundation_constructor">
                        <h3>Основа</h3>
                        <div class="osnova_buttons">
                          <button :class="main.id === ingredient.id ? 'osnova_btn menu_item_btn active' : 'osnova_btn menu_item_btn'" :data-main="ingredient.id" @click="main = {name: ingredient.name, id: ingredient.id}" v-for="(ingredient, index) in categories[2].additives[124].ingredients" :key="index">{{ingredient.name}}</button>
                        </div>
                        <h3>Начинка</h3>
                        <div class="nachinka_buttons">
                          <button :class="selectCategory === index ? 'nachinka_btn menu_item_btn active' : 'nachinka_btn menu_item_btn'" @click="selectCategory = index" v-if="index !== '125' && index !== '124'" v-for="(category, index) in categories[2].additives" :key="index">{{category.name}}</button>
                        </div>
                        <div class="add_meet" v-if="selectCategory">
                          <div class="add_meet_item" v-for="(ingredient, index) in categories[2].additives[selectCategory].ingredients" :key="index">
                            <p>{{ingredient.name}}</p>
                            <div class="plus_minus_meet_item">
                              <div class="minus" @click="mIng(ingredient.id, ingredient.name)">-</div>
                              <p id="number_of_meet_items" :data-ingredient="ingredient.id" v-if="ingredients[ingredient.id] && ingredients[ingredient.id].count">{{ingredients[ingredient.id].count}}</p>
                              <p id="number_of_meet_items" :data-ingredient="ingredient.id" v-else>0</p>
                              <div class="plus" @click="pIng(ingredient.id, ingredient.name)">+</div>

                            </div>

                          </div>
                        </div>
                        <div class="pick_size">
                          <h3>Размер</h3>
                          <button :class="size.id === ingredient.id ? 'pick_size_btn active' : 'pick_size_btn'" @click="size = {name: ingredient.name, id: ingredient.id}" v-for="(ingredient, index) in categories[2].additives[125].ingredients" :key="index">{{ingredient.name}}</button>
                        </div>
                      </div>

                    </div>
                    <h4 v-if="Object.keys(pizza).length">Пожелания по Вашим запросам</h4>
                    <div v-if="Object.keys(pizza).length" class="slider_wok">
                      <div class="item_wok slick-slide" v-for="(restaurant, index) in pizza" :key="index">
                        <div class="item_img_wok">
                          <img :src="restaurant.img">
                          <div class="overlay">
                            <p>{{restaurant.desc}}</p>
                          </div>
                        </div>
                        <div class="item_price_wok">
                          <div class="item_header">
                            <div class="title">
                              <h3>{{restaurant.name}}</h3>
                            </div>
                          </div>
                            <div class="wok_price">
                                <p>{{restaurant.amount}} руб<span></span></p>
                            </div>
                          <div class="button">
                            <button class="menu_item_btn" @click="sendPizza(restaurant)">ПОЕСТЬ</button>
                          </div>

                        </div>
                      </div>
                    </div>
                    <h4 v-if="Object.keys(readyPizza).length">Готовые блюда</h4>
                    <div v-if="Object.keys(readyPizza).length" class="slider_wok_2">
                      <div class="item_wok slick-slide" v-for="(product, index) in readyPizza" :key="index">
                        <div class="item_img_wok">
                          <img :src="product.photo" alt="lanches_slider_1">
                          <div class="overlay">
                            <p>{{product.desc}}</p>
                          </div>
                        </div>
                        <div class="item_price_wok">
                          <div class="item_header">
                            <div class="title">
                              <h3>{{product.name}}</h3>
                            </div>
                            <div class="town">
                              <p>{{product.restaurant_name}}</p>
                            </div>
                          </div>
                          <div class="wok_price">
                            <p>{{product.price}}<span>/{{product.weight}} {{product.weight_type}}</span></p>
                          </div>
                          <div class="button">
                            <button class="menu_item_btn" @click="putInBasket(product.id)">ПОЕСТЬ</button>
                          </div>

                        </div>
                      </div>
                    </div>

                  </div>
                  <h3 class="rest_item_title">
                    {{category.name}}
                  </h3>
                  <div class="restrunt_menu_wrapper">
                    <div :class="basket.amount && parseInt(basket.amount) !==0?'menu_container':'menu_container empty'">
                      <div class="sorting_block">

                        <div class="amount_of_dish">

                        </div>

                        <div class="buttons_wrapper">

                          <button @click="view = 'square'" type="button" :class="view==='square'?'menu_item_btn list_active':'menu_item_btn'">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/main/square.svg" alt="">
                            Плиткой
                          </button>

                          <button @click="view = 'list'" type="button" :class="view==='list'?'menu_item_btn list_active':'menu_item_btn'">
                            <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/main/list.svg" alt="">
                            Списком
                          </button>

                        </div>
                      </div>

                      <div v-if="view === 'list'" class="list_view">
                        <div class="dishes_list">
                          <div :class="index%2?'dish bg_color':'dish'" v-for="(product, index) in products.standart" v-if="product.show && (product.category !== 15 && Object.values(product.additives).join(',') !== '67')" :key="product.id">
                            <div class="dish_name">
                              <h3>{{product.name}}</h3>
                              <h4>{{product.restaurant_name}}</h4>
                              <div class="item">
                                <div class="title">
                                  <h4>{{product.name}}</h4>
                                  <!-- a href="#" v-if="product.stocks" class="stock">Акция</a-->
                                </div>
                                <div class="main_description">
                                  <img :src="product.photo" :alt="product.name">
                                  <div class="link_row">
                                    <router-link :to="'/restaurant/' + product.restaurant_id" class="rest_name">{{product.restaurant_name}}</router-link>
                                    <p class="delivery_time">{{product.delivery_time}} мин</p>
                                  </div>
                                </div>
                                <div class="text_row">
                                  <p>{{product.desc}}</p>
                                </div>
                                <div class="prise_row">
                                  <p><strong>{{product.price}}</strong> / {{product.weight}} {{product.weight_type}}</p>
                                  <button class="menu_item_btn" @click="putInBasket(product.id)">Поесть</button>
                                </div>
                              </div>
                            </div>
                            <div class="dish_middle">
                              <span class="price">{{product.price}} </span>
                              <span class="weight">/{{product.weight}} {{product.weight_type}}</span>
                            </div>
                            <button type="button" class="menu_item_btn" @click="putInBasket(product.id)">Поесть</button>
                          </div>
                        </div>
                      </div>

                      <div v-if="view === 'square'" class="square_view">
                        <div class="items_group">
                                <slot v-for="product in products.standart">
                                    <item-block v-if="product.show && (product.category !== 15 && Object.values(product.additives).join(',') !== '67')" :key="product.id" :product.sync="product" :basket.sync="basket"></item-block>
                                </slot>
                        </div>
                      </div>
                      <!-------Show more(button)----------->

                    </div>
                    <cart-sidebar :basket.sync="basket" :auth.sync="auth"></cart-sidebar>
                  </div>
                </div>
                <div class="order_lunch_wrapper" v-else-if="category.id === 9">
                    <div v-if="1===0 && orderRestaurant" class="calendar_box" style="transform: translateY(-50%);position: fixed;left: 0;right: 0;top: 40%;z-index: 999;margin:auto">
                        <div class="calendar_title">
                            <h1 style="display: inline-block;">Выберите даты</h1>
                            <button class="cross" style="background: none;border: 0; float: right"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/referals/cross.svg" @click="orderRestaurant = null, orderType = null"></button>
                        </div>
                        <div class="bootstrap_calendar"></div>
                        <div class="number_box">
                            <p>Количество персон: </p>
                            <div class="number">
                                <span class="minus" @click="countPersons--">-</span>
                                <input type="text" v-model="countPersons"/>
                                <span class="plus" @click="countPersons++">+</span>
                            </div>
                        </div>
                        <div class="number_box">
                            <p>Количество дней: </p>
                            <div class="number">
                                <span class="minus" @click="countDays--">-</span>
                                <input type="text" v-model="countDays"/>
                                <span class="plus" @click="countDays++">+</span>
                            </div>
                        </div>
                        <div class="price_box">
                            <span>{{products[orderType][orderRestaurant].amount}} руб</span>
                            <button class="menu_item_btn" @click="goOrder">ПОЕСТЬ</button>
                        </div>
                    </div>
                    <h3 class="order_lunch_title">{{category.name}}</h3>
                    <div class="order_lunch" v-if="products.lunch && restaurant.show" v-for="(restaurant, index) in products.lunch" :key="'lunch' + index">
                        <div class="order_lunch_row o_l_r_first">
                            <div class="logo_name">
                                <img :src="restaurant.img" alt="susi_ears">
                                <div class="name">
                                    <h3>{{restaurant.name}}</h3>
                                    <p>Кухня: {{ Object.values(restaurant.categories).join(', ') }}</p>
                                </div>
                            </div>
                            <div class="min_amount_worktime">
                                <div v-if="parseInt(restaurant.minimal_amount) > 0" class="column">
                                    <p>Заказ от {{parseInt(restaurant.minimal_amount)}} руб.</p>
                                </div>
                                <div class="column" v-if="parseInt(restaurant.delivery_price) && parseInt(restaurant.free_from) !== 0">
                                    <p>Доставка {{restaurant.delivery_price}} руб.</p>
                                </div>
                                <div v-if="parseInt(restaurant.free_from) > 0" class="column">
                                    <p>От {{restaurant.free_from}} руб. бесплатная доставка</p>
                                </div>
                                <div v-if="parseInt(restaurant.free_from) === 0" class="column">
                                    <p>бесплатная доставка</p>
                                </div>
                                <div class="column" >
                                    <p>Доставим за {{restaurant.delivery_time}} мин</p>
                                </div>
                                <div class="column" v-if="(restaurant.from === '00:00' || restaurant.from === '00:00:00') && restaurant.to === '23:59'">
                                    <p>круглосуточно время работы</p>
                                </div>
                                <div class="column" v-else>
                                    <p>{{restaurant.from}} - {{restaurant.to}} время работы</p>
                                </div>
                                <div class="bottom_column">
                                    <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/lanches/bg.png" alt="">
                                    <p><strong>!</strong> Для сравнения добавьте 2 и более блюд</p>
                                </div>

                            </div>
                        </div>
                        <div class="order_lunch_row o_l_r_second">
                            <div class="left">
                                <button :class="restaurant.param1 === 'Завтрак' ? 'orange_sqr_button active' : 'orange_sqr_button'" @click="restaurant.param1 = 'Завтрак', deleteLunch(restaurant.id)">Завтрак</button>
                                <button :class="restaurant.param1 === 'Обед' ? 'orange_sqr_button active' : 'orange_sqr_button'" @click="restaurant.param1 = 'Обед', deleteLunch(restaurant.id)">Обед</button>
                                <button :class="restaurant.param1 === 'Ужин' ? 'orange_sqr_button active' : 'orange_sqr_button'" @click="restaurant.param1 = 'Ужин', deleteLunch(restaurant.id)">Ужин</button>
                            </div>
                            <div class="dey_week">
                                <button :class="restaurant.param2 === 'Пн' ? 'orange_sqr_button active' : 'orange_sqr_button'" @click="restaurant.param2 = 'Пн', deleteLunch(restaurant.id)">Пн</button>
                                <button :class="restaurant.param2 === 'Вт' ? 'orange_sqr_button active' : 'orange_sqr_button'" @click="restaurant.param2 = 'Вт', deleteLunch(restaurant.id)">Вт</button>
                                <button :class="restaurant.param2 === 'Ср' ? 'orange_sqr_button active' : 'orange_sqr_button'" @click="restaurant.param2 = 'Ср', deleteLunch(restaurant.id)">Ср</button>
                                <button :class="restaurant.param2 === 'Чт' ? 'orange_sqr_button active' : 'orange_sqr_button'" @click="restaurant.param2 = 'Чт', deleteLunch(restaurant.id)">Чт</button>
                                <button :class="restaurant.param2 === 'Пт' ? 'orange_sqr_button active' : 'orange_sqr_button'" @click="restaurant.param2 = 'Пт', deleteLunch(restaurant.id)">Пт</button>
                                <button :class="restaurant.param2 === 'Сб' ? 'orange_sqr_button active' : 'orange_sqr_button'" @click="restaurant.param2 = 'Сб', deleteLunch(restaurant.id)">Сб</button>
                                <button :class="restaurant.param2 === 'Вс' ? 'orange_sqr_button active' : 'orange_sqr_button'" @click="restaurant.param2 = 'Вс', deleteLunch(restaurant.id)">Вс</button>
                                <button class="compare" style="display: none">Сравнить</button>

                            </div>
                        </div>
                        <div class="order_lunch_row_slider">
                            <div v-for="product in restaurant.products" :key="product.id" :class="!product.param1.split(',').includes(restaurant.param1) || !product.param2.split(',').includes(restaurant.param2) ? 'item hide' : 'item'"  @click="selectLunch('lunch', product.restaurant_id, product.id, product.price)">
                                <div class="overlay">
                                    <p>{{product.desc}}</p>
                                </div>
                                <div class="item_img">
                                    <img :src="product.photo">
                                </div>
                                <div class="item_price">
                                    <h4>{{product.name}}</h4>
                                    <div class="price_box">
                                        <p>{{product.price}}<span>/{{product.weight}} {{product.weight_type}}</span></p>
                                        <button :data-product="product.id" :data-restaurant="product.restaurant_id" :class="selectedLunch.lunch && selectedLunch.lunch[product.restaurant_id] && selectedLunch.lunch[product.restaurant_id][product.id] ? 'price_box_btn active':'price_box_btn'"></button>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="order_lunch_row fourth_row">
                            <div class="left">
                                <div class="left_second_col">
                                    <div class="total_amount">
                                        <span>Итого: {{restaurant.amount}} руб</span>
                                    </div>
                                </div>
                            </div>
                            <div class="right">

                                <div class="button">
                                    <button class="menu_item_btn" @click="orderType = 'lunch', orderRestaurant = restaurant.id">Поесть</button>
                                </div>
                            </div>

                        </div>

                    </div>
                    <div class="order_lunch" v-if="products.standart && restaurant.show" v-for="(restaurant, index) in products.standart" :key="index">
                        <div class="order_lunch_row o_l_r_first">
                            <div class="logo_name">
                                <img :src="restaurant.img" alt="susi_ears">
                                <div class="name">
                                    <h3>{{restaurant.name}}</h3>
                                    <p>Кухня: {{ Object.values(restaurant.categories).join(', ') }}</p>
                                </div>
                            </div>
                            <div class="min_amount_worktime">
                                <div v-if="parseInt(restaurant.minimal_amount) > 0" class="column">
                                    <p>Заказ от {{parseInt(restaurant.minimal_amount)}} руб.</p>
                                </div>
                                <div class="column" v-if="parseInt(restaurant.delivery_price) && parseInt(restaurant.free_from) !== 0">
                                    <p>Доставка {{restaurant.delivery_price}} руб.</p>
                                </div>
                                <div v-if="parseInt(restaurant.free_from) > 0" class="column">
                                    <p>От {{restaurant.free_from}} руб. бесплатная доставка</p>
                                </div>
                                <div v-if="parseInt(restaurant.free_from) === 0" class="column">
                                    <p>бесплатная доставка</p>
                                </div>
                                <div class="column" >
                                    <p>Доставим за {{restaurant.delivery_time}} мин</p>
                                </div>
                                <div class="column" v-if="(restaurant.from === '00:00' || restaurant.from === '00:00:00') && restaurant.to === '23:59'">
                                    <p>круглосуточно время работы</p>
                                </div>
                                <div class="column" v-else>
                                    <p>{{restaurant.from}} - {{restaurant.to}} время работы</p>
                                </div>
                                <div class="bottom_column">
                                    <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/lanches/bg.png" alt="">
                                    <p><strong>!</strong> Для сравнения добавьте 2 и более блюд</p>
                                </div>

                            </div>
                        </div>
                        <div class="order_lunch_row o_l_r_second" style="display: none">
                            <div class="dey_week">
                                <button class="compare">Сравнить</button>
                            </div>
                        </div>
                        <div class="order_lunch_row_slider">
                            <div class="item slick-slide" v-for="product in restaurant.products" :key="product.id" @click="selectLunch('standart', product.restaurant_id, product.id, product.price)">
                                <div class="overlay">
                                    <p>{{product.desc}}</p>
                                </div>
                                <div class="item_img">
                                    <img :src="product.photo">
                                </div>
                                <div class="item_price">
                                    <h4>{{product.name}}</h4>
                                    <div class="price_box">
                                        <p>{{product.price}}<span>/{{product.weight}} {{product.weight_type}}</span></p>
                                        <button :data-product="product.id" :class="selectedLunch.standart && selectedLunch.standart[product.restaurant_id] && selectedLunch.standart[product.restaurant_id][product.id] ? 'price_box_btn active':'price_box_btn'"></button>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="order_lunch_row fourth_row">
                            <div class="left">
                                <div class="left_second_col">
                                    <div class="total_amount">
                                        <span>Итого: {{restaurant.amount}} руб</span>
                                    </div>
                                </div>
                            </div>
                            <div class="right">

                                <div class="button">
                                    <button class="menu_item_btn" @click="orderType = 'standart', orderRestaurant = restaurant.id">Поесть</button>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
                <div class="order_lunch_wrapper" v-else-if="category.id === 15">
                      <div v-if="currentCake" class="pop_up_cake_wrapper">

                          <div class="pop_up_cake">
                              <button class="cross" style="background: none; border: 0;position: absolute;top: 10px;right: 10px"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/referals/cross.svg" @click="currentCake = null, selectFill = null"></button>
                              <div class="row_2">
                                  <div class="cake_img">
                                      <img :src="currentCake.photo" alt="salat">
                                  </div>
                                  <div class="description">
                                      <h3>{{currentCake.name}}</h3>
                                      <p class="pop_up_cake_price" ><span>{{currentCake.price}}</span> <span> за 1 кг</span></p>
                                      <!--p>Под заказ - от 6 часов</p-->
                                      <p>Минимальный заказ - {{currentCake.param1}}кг</p>
                                  </div>
                                  <p class="row_2_text">{{currentCake.desc}}</p>
                              </div>
                              <div class="slider_title">
                                  <h3>Начинки</h3>
                              </div>
                              <div class="row_3 pou_up_cake_slider">
                                  <div class="item" v-for="(fill, fId) in products.fill[currentCake.restaurant_id].products" :key="fId" @click="selectFill = fill">
                                      <div class="col">
                                          <div class="item_title">
                                              <img :src="fill.photo" alt="logo_tiramisu">
                                              <h2>{{fill.name}}</h2>
                                          </div>
                                          <button :class="selectFill === fill?'add_btn active':'add_btn'">+</button>
                                      </div>
                                      <p class="desc_tiramisu">{{fill.desc}}
                                          <span class="desc_tiramisu_full">{{fill.desc}}</span>
                                      </p>
                                  </div>
                              </div>
                              <div class="row_1">
                                  <div class="option_box">
                                      <span>Количество ярусов</span>
                                      <div class="counter">
                                          <span class="counter_btn" @click="floors--">-</span>
                                          <input type="text" v-model="floors"/>
                                          <span class="counter_btn" @click="floors++">+</span>
                                      </div>
                                  </div>
                                  <div class="option_box">
                                      <span>Количество слоев</span>
                                      <div class="counter">
                                          <span class="counter_btn" @click="layers--">-</span>
                                          <input type="text" v-model="layers"/>
                                          <span class="counter_btn" @click="layers++">+</span>
                                      </div>
                                  </div>
                                  <div class="option_box">
                                      <span>Вес, кг</span>
                                      <div class="counter">
                                          <span class="counter_btn"  @click="weight--">-</span>
                                          <input type="text" v-model="weight"/>
                                          <span class="counter_btn"  @click="weight++">+</span>
                                      </div>
                                  </div>
                              </div>

                              <div class="row_4">
                                  <div class="row_4_left">
                                      <textarea placeholder="Пожелания" name="pup_up_cake_message" id="" cols="30" rows="10"></textarea>
                                  </div>
                                  <div class="row_4_right">
                                      <input class="file_input" id="cake_file" name="cake_file[]" type="file" ref="files" multiple v-on:change="handleFileUploads()" style="display: none">
                                      <label for="cake_file" class="add_photo">Прикрепить фото</label>
                                      <div class="remove_photo" v-for="(photo, pId) in photos" :key="pId">
                                          <p class="photo_name" style="text-overflow: ellipsis;width: 130px;overflow: hidden;white-space: nowrap;">{{photo.name}}</p>
                                          <button @click="deletePhoto(photo)"></button>
                                      </div>

                                  </div>

                              </div>
                              <div class="row_5">
                                  <p>Оплата после подтверждения заказа | Мы обязательно перезвоним для уточнения подробностей</p>
                              </div>
                              <div class="row_6">
                                  <span class="price">{{priceCake}} руб</span>
                                  <button @click="sendCake">ОТПРАВИТЬ ЗАЯВКУ</button>
                              </div>

                          </div>

                      </div>

                      <h3 class="order_lunch_title">{{category.name}}</h3>
                      <div class="order_lunch" v-if="products.cake && restaurant.show" v-for="(restaurant, index) in products.cake" :key="index">
                          <div class="order_lunch_row o_l_r_first">
                              <div class="logo_name">
                                  <img :src="restaurant.img" alt="susi_ears">
                                  <div class="name">
                                      <h3>{{restaurant.name}}</h3>
                                      <p>Кухня: {{ Object.values(restaurant.categories).join(', ') }}</p>
                                  </div>
                              </div>
                              <div class="min_amount_worktime">
                                  <div v-if="parseInt(restaurant.minimal_amount) > 0" class="column">
                                      <p>Заказ от {{parseInt(restaurant.minimal_amount)}} руб.</p>
                                  </div>
                                  <div class="column" v-if="parseInt(restaurant.delivery_price) && parseInt(restaurant.free_from) !== 0">
                                      <p>Доставка {{restaurant.delivery_price}} руб.</p>
                                  </div>
                                  <div v-if="parseInt(restaurant.free_from) > 0" class="column">
                                      <p>От {{restaurant.free_from}} руб. бесплатная доставка</p>
                                  </div>
                                  <div v-if="parseInt(restaurant.free_from) === 0" class="column">
                                      <p>бесплатная доставка</p>
                                  </div>
                                  <div class="column" >
                                      <p>Доставим за {{restaurant.delivery_time}} мин</p>
                                  </div>
                                  <div class="column" v-if="(restaurant.from === '00:00' || restaurant.from === '00:00:00') && restaurant.to === '23:59'">
                                      <p>круглосуточно время работы</p>
                                  </div>
                                  <div class="column" v-else>
                                      <p>{{restaurant.from}} - {{restaurant.to}} время работы</p>
                                  </div>
                                  <div class="bottom_column">
                                      <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/lanches/bg.png" alt="">
                                      <p><strong>!</strong> Для сравнения добавьте 2 и более блюд</p>
                                  </div>

                              </div>
                          </div>
                          <div class="order_lunch_row o_l_r_second" style="display: none">
                              <div class="dey_week">
                                  <button class="compare">Сравнить</button>
                              </div>
                          </div>
                          <div class="order_lunch_row_slider">
                              <div class="item slick-slide" v-for="(product, pIndex) in restaurant.products" :key="product.id" @click="selectCake = pIndex">
                                  <div class="overlay">
                                      <p>{{product.desc}}</p>
                                  </div>
                                  <div class="item_img">
                                      <img :src="product.photo" loading="lazy">
                                  </div>
                                  <div class="item_price">
                                      <h4>{{product.name}}</h4>
                                      <div class="price_box">
                                          <p>{{product.price}}<span> за 1 кг</span></p>
                                          <button :data-product="product.id" :class="selectCake === pIndex ? 'price_box_btn active':'price_box_btn'"></button>
                                      </div>

                                  </div>
                              </div>
                          </div>
                          <div class="order_lunch_row fourth_row">
                              <div class="right">

                                  <div class="button">
                                      <button class="menu_item_btn" @click="selectsCake(index)">Продолжить</button>
                                  </div>
                              </div>

                          </div>

                      </div>
                  </div>
                <div class="order_lunch_wrapper" v-else-if="category.id === 21">
                      <div v-if="currentProgram" class="pop_up_healthy_wrapper" style="transform: translateY(-50%);position: fixed;left: 0;right: 0;top: 50%;z-index: 999;margin:auto">
                          <div class="pop_up_healthy" style="position: relative">
                              <button class="cross" style="background: none; border: 0;position: absolute;top: 10px;right: 10px"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/referals/cross.svg" @click="currentProgram = null"></button>
                              <div class="row_1">
                                  <div class="logo">
                                      <img :src="currentProgram.photo" alt="" style="width: 40px;height: 40px;">
                                  </div>
                                  <div class="title">
                                      <h3>{{currentProgram.name}}</h3>
                                  </div>
                              </div>
                              <div class="row_3">
                                  <p>{{currentProgram.desc}}</p>
                              </div>
                              <div class="row_4">
                                  <h1>Обзор подборок</h1>
                                  <div class="week_slider">
                                      Неделя:
                                      <div class="days_buttons weeks">
                                          <button :class="currentProgram.param1 === '1' ? 'day_button active' : 'day_button'" @click="currentProgram.param1 = '1'">1</button>
                                          <button :class="currentProgram.param1 === '2' ? 'day_button active' : 'day_button'" @click="currentProgram.param1 = '2'">2</button>
                                      </div>
                                  </div>
                                  <div class="week_slider">
                                      <div class="days_buttons">
                                          <button class="day_button" :class="currentProgram.param2 === 'Пн' ? 'day_button active' : 'day_button'" @click="currentProgram.param2 = 'Пн'">Пн</button>
                                          <button class="day_button" :class="currentProgram.param2 === 'Вт' ? 'day_button active' : 'day_button'" @click="currentProgram.param2 = 'Вт'">Вт</button>
                                          <button class="day_button" :class="currentProgram.param2 === 'Ср' ? 'day_button active' : 'day_button'" @click="currentProgram.param2 = 'Ср'">Ср</button>
                                          <button class="day_button" :class="currentProgram.param2 === 'Чт' ? 'day_button active' : 'day_button'" @click="currentProgram.param2 = 'Чт'">Чт</button>
                                          <button class="day_button" :class="currentProgram.param2 === 'Пт' ? 'day_button active' : 'day_button'" @click="currentProgram.param2 = 'Пт'">Пт</button>
                                          <button class="day_button" :class="currentProgram.param2 === 'Сб' ? 'day_button active' : 'day_button'" @click="currentProgram.param2 = 'Сб'">Сб</button>
                                          <button class="day_button" :class="currentProgram.param2 === 'Вс' ? 'day_button active' : 'day_button'" @click="currentProgram.param2 = 'Вс'">Вс</button>
                                      </div>
                                  </div>
                              </div>
                              <div class="row_5 ">
                                  <div class="pop_up_healthy_slider_wrapper">
                                      <div class="pop_up_healthy_slider">
                                          <div v-for="product in products.health[currentProgram.restaurant_id].products" :key="product.id" :class="!product.param1.split(',').includes(currentProgram.param1) || !product.param2.split(',').includes(currentProgram.param2) || !product.param3.split(',').includes(currentProgram.id.toString()) ? 'item hide' : 'item'">
                                              <div class="item_img">
                                                  <img :src="product.photo" alt="healthy_slider_1">
                                              </div>
                                              <div class="item_price">
                                                  <h4>Описание</h4>
                                                  <div class="links">{{product.desc}}
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                              </div>
                              <div class="row_6">
                                  <p>Уже пробовали эту программу? Оставьте <a href="#">отзыв</a>!</p>
                              </div>
                              <div class="row_7">
                                  <div class="left">
                                      <div class="left_1">
                                          <P>{{currentProgram.price}} <span class="day">/ день</span></P>
                                      </div>
                                  </div>
                                  <div class="right">
                                      <button class="menu_item_btn" @click="sendHealth">Заказать</button>
                                  </div>
                              </div>

                          </div>
                      </div>

                      <h3 class="order_lunch_title">{{category.name}}</h3>
                      <div class="order_lunch" v-if="products.program && restaurant.show" v-for="(restaurant, index) in products.program" :key="index">
                          <div class="order_lunch_row o_l_r_first">
                              <div class="logo_name">
                                  <img :src="restaurant.img" alt="susi_ears">
                                  <div class="name">
                                      <h3>{{restaurant.name}}</h3>
                                      <p>Кухня: {{ Object.values(restaurant.categories).join(', ') }}</p>
                                  </div>
                              </div>
                              <div class="min_amount_worktime">
                                  <div v-if="parseInt(restaurant.minimal_amount) > 0" class="column">
                                      <p>Заказ от {{parseInt(restaurant.minimal_amount)}} руб.</p>
                                  </div>
                                  <div class="column" v-if="parseInt(restaurant.delivery_price) && parseInt(restaurant.free_from) !== 0">
                                      <p>Доставка {{restaurant.delivery_price}} руб.</p>
                                  </div>
                                  <div v-if="parseInt(restaurant.free_from) > 0" class="column">
                                      <p>От {{restaurant.free_from}} руб. бесплатная доставка</p>
                                  </div>
                                  <div v-if="parseInt(restaurant.free_from) === 0" class="column">
                                      <p>бесплатная доставка</p>
                                  </div>
                                  <div class="column" >
                                      <p>Доставим за {{restaurant.delivery_time}} мин</p>
                                  </div>
                                  <div class="column" v-if="(restaurant.from === '00:00' || restaurant.from === '00:00:00') && restaurant.to === '23:59'">
                                      <p>круглосуточно время работы</p>
                                  </div>
                                  <div class="column" v-else>
                                      <p>{{restaurant.from}} - {{restaurant.to}} время работы</p>
                                  </div>
                                  <div class="bottom_column">
                                      <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/lanches/bg.png" alt="">
                                      <p><strong>!</strong> Для сравнения добавьте 2 и более блюд</p>
                                  </div>

                              </div>
                          </div>
                          <div class="order_lunch_row o_l_r_second" style="display: none">
                              <div class="dey_week">
                                  <button class="compare">Сравнить</button>
                              </div>
                          </div>
                          <div class="order_lunch_row_slider">
                              <div class="item slick-slide" v-for="(product, pIndex) in restaurant.products" :key="product.id" @click="selectProgram = pIndex">
                                  <div class="overlay">
                                      <p>{{product.desc}}</p>
                                  </div>
                                  <div class="item_img">
                                      <img :src="product.photo">
                                  </div>
                                  <div class="item_price">
                                      <h4>{{product.name}}</h4>
                                      <div class="price_box">
                                          <p>{{product.price}}</p>
                                          <button :data-product="product.id" :class="selectProgram === pIndex ? 'price_box_btn active':'price_box_btn'"></button>
                                      </div>

                                  </div>
                              </div>
                          </div>
                          <div class="order_lunch_row fourth_row">
                              <div class="right">

                                  <div class="button">
                                      <button class="menu_item_btn" @click="selectsProgram(index)">Продолжить</button>
                                  </div>
                              </div>

                          </div>

                      </div>
                  </div>
                <div class="order_lunch_wrapper" v-else-if="category.id === 29">
                    <h3 class="order_lunch_title">{{category.name}}</h3>
                    <div class="order_lunch" v-if="products.subs && restaurant.show" v-for="(restaurant, index) in products.subs" :key="index">
                        <div class="order_lunch_row o_l_r_first">
                            <div class="logo_name">
                                <img :src="restaurant.img" alt="susi_ears">
                                <div class="name">
                                    <h3>{{restaurant.name}}</h3>
                                    <p>Кухня: {{ Object.values(restaurant.categories).join(', ') }}</p>
                                </div>
                            </div>
                            <div class="min_amount_worktime">
                                <div v-if="parseInt(restaurant.minimal_amount) > 0" class="column">
                                    <p>Заказ от {{parseInt(restaurant.minimal_amount)}} руб.</p>
                                </div>
                                <div class="column" v-if="parseInt(restaurant.delivery_price) && parseInt(restaurant.free_from) !== 0">
                                    <p>Доставка {{restaurant.delivery_price}} руб.</p>
                                </div>
                                <div v-if="parseInt(restaurant.free_from) > 0" class="column">
                                    <p>От {{restaurant.free_from}} руб. бесплатная доставка</p>
                                </div>
                                <div v-if="parseInt(restaurant.free_from) === 0" class="column">
                                    <p>бесплатная доставка</p>
                                </div>
                                <div class="column" >
                                    <p>Доставим за {{restaurant.delivery_time}} мин</p>
                                </div>
                                <div class="column" v-if="(restaurant.from === '00:00' || restaurant.from === '00:00:00') && restaurant.to === '23:59'">
                                    <p>круглосуточно время работы</p>
                                </div>
                                <div class="column" v-else>
                                    <p>{{restaurant.from}} - {{restaurant.to}} время работы</p>
                                </div>
                                <div class="bottom_column">
                                    <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/lanches/bg.png" alt="">
                                    <p><strong>!</strong> Для сравнения добавьте 2 и более блюд</p>
                                </div>

                            </div>
                        </div>
                        <div class="order_lunch_row o_l_r_second">
                            <div class="left">
                                <button :class="restaurant.param1 === 'Завтрак' ? 'orange_sqr_button active' : 'orange_sqr_button'" @click="restaurant.param1 = 'Завтрак', deleteLunch(restaurant.id)">Завтрак</button>
                                <button :class="restaurant.param1 === 'Обед' ? 'orange_sqr_button active' : 'orange_sqr_button'" @click="restaurant.param1 = 'Обед', deleteLunch(restaurant.id)">Обед</button>
                                <button :class="restaurant.param1 === 'Ужин' ? 'orange_sqr_button active' : 'orange_sqr_button'" @click="restaurant.param1 = 'Ужин', deleteLunch(restaurant.id)">Ужин</button>
                            </div>
                            <div class="dey_week">
                                <button :class="restaurant.param2 === 'Пн' ? 'orange_sqr_button active' : 'orange_sqr_button'" @click="restaurant.param2 = 'Пн', deleteLunch(restaurant.id)">Пн</button>
                                <button :class="restaurant.param2 === 'Вт' ? 'orange_sqr_button active' : 'orange_sqr_button'" @click="restaurant.param2 = 'Вт', deleteLunch(restaurant.id)">Вт</button>
                                <button :class="restaurant.param2 === 'Ср' ? 'orange_sqr_button active' : 'orange_sqr_button'" @click="restaurant.param2 = 'Ср', deleteLunch(restaurant.id)">Ср</button>
                                <button :class="restaurant.param2 === 'Чт' ? 'orange_sqr_button active' : 'orange_sqr_button'" @click="restaurant.param2 = 'Чт', deleteLunch(restaurant.id)">Чт</button>
                                <button :class="restaurant.param2 === 'Пт' ? 'orange_sqr_button active' : 'orange_sqr_button'" @click="restaurant.param2 = 'Пт', deleteLunch(restaurant.id)">Пт</button>
                                <button :class="restaurant.param2 === 'Сб' ? 'orange_sqr_button active' : 'orange_sqr_button'" @click="restaurant.param2 = 'Сб', deleteLunch(restaurant.id)">Сб</button>
                                <button :class="restaurant.param2 === 'Вс' ? 'orange_sqr_button active' : 'orange_sqr_button'" @click="restaurant.param2 = 'Вс', deleteLunch(restaurant.id)">Вс</button>
                                <button class="compare" style="display: none">Сравнить</button>

                            </div>
                        </div>
                        <div class="order_lunch_row_slider">
                            <div v-for="product in restaurant.products" :key="product.id" :class="!product.param1.split(',').includes(restaurant.param1) || !product.param2.split(',').includes(restaurant.param2) ? 'item hide' : 'item'"  @click="selectLunch('subs', product.restaurant_id, product.id, product.price)">
                                <div class="overlay">
                                    <p>{{product.desc}}</p>
                                </div>
                                <div class="item_img">
                                    <img :src="product.photo">
                                </div>
                                <div class="item_price">
                                    <h4>{{product.name}}</h4>
                                    <div class="price_box">
                                        <p>{{product.price}}<span>/{{product.weight}} {{product.weight_type}}</span></p>
                                        <button :data-product="product.id" :data-restaurant="product.restaurant_id" :class="selectedLunch.subs && selectedLunch.lunch[product.restaurant_id] && selectedLunch.subs[product.restaurant_id][product.id] ? 'price_box_btn active':'price_box_btn'"></button>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="order_lunch_row fourth_row">
                            <div class="left">
                                <div class="left_second_col">
                                    <div class="total_amount">
                                        <span>Итого: {{restaurant.amount}} руб</span>
                                    </div>
                                </div>
                            </div>
                            <div class="right">

                                <div class="button">
                                    <button class="menu_item_btn" @click="orderType = 'subs', orderRestaurant = restaurant.id">Поесть</button>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
                <div class="order_lunch_wrapper" v-else-if="category.id === 30">
                      <h3 class="order_lunch_title">{{category.name}}</h3>
                      <div class="order_lunch" v-if="products.standart && restaurant.show" v-for="(restaurant, index) in products.standart" :key="index">
                          <div class="order_lunch_row o_l_r_first">
                              <div class="logo_name">
                                  <img :src="restaurant.img" alt="susi_ears">
                                  <div class="name">
                                      <h3>{{restaurant.name}}</h3>
                                      <p>Кухня: {{ Object.values(restaurant.categories).join(', ') }}</p>
                                  </div>
                              </div>
                              <div class="min_amount_worktime">
                                  <div v-if="parseInt(restaurant.minimal_amount) > 0" class="column">
                                      <p>Заказ от {{parseInt(restaurant.minimal_amount)}} руб.</p>
                                  </div>
                                  <div class="column" v-if="parseInt(restaurant.delivery_price) && parseInt(restaurant.free_from) !== 0">
                                      <p>Доставка {{restaurant.delivery_price}} руб.</p>
                                  </div>
                                  <div v-if="parseInt(restaurant.free_from) > 0" class="column">
                                      <p>От {{restaurant.free_from}} руб. бесплатная доставка</p>
                                  </div>
                                  <div v-if="parseInt(restaurant.free_from) === 0" class="column">
                                      <p>бесплатная доставка</p>
                                  </div>
                                  <div class="column" >
                                      <p>Доставим за {{restaurant.delivery_time}} мин</p>
                                  </div>
                                  <div class="column" v-if="(restaurant.from === '00:00' || restaurant.from === '00:00:00') && restaurant.to === '23:59'">
                                      <p>круглосуточно время работы</p>
                                  </div>
                                  <div class="column" v-else>
                                      <p>{{restaurant.from}} - {{restaurant.to}} время работы</p>
                                  </div>
                                  <div class="bottom_column">
                                      <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/lanches/bg.png" alt="">
                                      <p><strong>!</strong> Для сравнения добавьте 2 и более блюд</p>
                                  </div>

                              </div>
                          </div>
                          <div class="order_lunch_row o_l_r_second" style="display: none">
                              <div class="dey_week">
                                  <button class="compare">Сравнить</button>
                              </div>
                          </div>
                          <div class="order_lunch_row_slider">
                              <div class="item slick-slide" v-for="product in restaurant.products" :key="product.id" @click="selectLunch('standart', product.restaurant_id, product.id, product.price)">
                                  <div class="overlay">
                                      <p>{{product.desc}}</p>
                                  </div>
                                  <div class="item_img">
                                      <img :src="product.photo">
                                  </div>
                                  <div class="item_price">
                                      <h4>{{product.name}}</h4>
                                      <div class="price_box">
                                          <p>{{product.price}}<span>/{{product.weight}} {{product.weight_type}}</span></p>
                                          <button :data-product="product.id" :class="selectedLunch.standart && selectedLunch.standart[product.restaurant_id] && selectedLunch.standart[product.restaurant_id][product.id] ? 'price_box_btn active':'price_box_btn'"></button>
                                      </div>

                                  </div>
                              </div>
                          </div>
                          <div class="order_lunch_row fourth_row">
                              <div class="left">
                                  <div class="left_second_col">
                                      <div class="total_amount">
                                          <span>Итого: {{restaurant.amount}} руб</span>
                                      </div>
                                  </div>
                              </div>
                              <div class="right">

                                  <div class="button">
                                      <button class="menu_item_btn" @click="orderType = 'standart', orderRestaurant = restaurant.id">Поесть</button>
                                  </div>
                              </div>

                          </div>

                      </div>
                  </div>
                <div class="create_wok_wrapper" v-else-if="category.id === 33">
                      <div class="create_wok_wrapper_title" v-if="categories[33]&& categories[33].additives[123]">
                          <h3 class="create_wok_title">Создать свой WOK</h3>
                          <button type="button" class="choice_toggle" id="constructor_toggle"></button>
                      </div>
                      <div class="create_wok" v-if="categories[33]&& categories[33].additives[123]">
                          <div class="foundation">
                              <div class="logo">
                                  <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/wok/wok_logo.png" alt="wok_logo">
                              </div>
                              <div class="foundation_constructor">
                                  <h3>Основа</h3>
                                  <div class="osnova_buttons">
                                      <button :class="main.id === ingredient.id ? 'osnova_btn menu_item_btn active' : 'osnova_btn menu_item_btn'" :data-main="ingredient.id" @click="main = {name: ingredient.name, id: ingredient.id}" v-for="(ingredient, index) in categories[33].additives[123].ingredients" :key="index">{{ingredient.name}}</button>
                                  </div>
                                  <h3>Начинка</h3>
                                  <div class="nachinka_buttons">
                                      <button :class="selectCategory === index ? 'nachinka_btn menu_item_btn active' : 'nachinka_btn menu_item_btn'" @click="selectCategory = index" v-if="index !== '123'" v-for="(category, index) in categories[33].additives" :key="index">{{category.name}}</button>
                                  </div>
                                  <div class="add_meet" v-if="selectCategory">
                                      <div class="add_meet_item" v-for="(ingredient, index) in categories[33].additives[selectCategory].ingredients" :key="index">
                                          <p>{{ingredient.name}}</p>
                                          <div class="plus_minus_meet_item">
                                              <div class="minus" @click="mIng(ingredient.id, ingredient.name)">-</div>
                                              <p id="number_of_meet_items" :data-ingredient="ingredient.id" v-if="ingredients[ingredient.id] && ingredients[ingredient.id].count">{{ingredients[ingredient.id].count}}</p>
                                              <p id="number_of_meet_items" :data-ingredient="ingredient.id" v-else>0</p>
                                              <div class="plus" @click="pIng(ingredient.id, ingredient.name)">+</div>

                                          </div>

                                      </div>
                                  </div>
                              </div>

                          </div>
                          <h4 v-if="Object.keys(wok).length">Пожелания по Вашим запросам</h4>
                          <div v-if="Object.keys(wok).length" class="slider_wok">
                              <div class="item_wok slick-slide" v-for="(restaurant, index) in wok" :key="index">
                                  <div class="item_img_wok">
                                      <img :src="restaurant.img">
                                      <div class="overlay">
                                          <p>{{restaurant.desc}}</p>
                                      </div>
                                  </div>
                                  <div class="item_price_wok">
                                      <div class="item_header">
                                          <div class="title">
                                              <h3>{{restaurant.name}}</h3>
                                          </div>
                                      </div>
                                      <div class="wok_price">
                                          <p>{{restaurant.amount}} руб<span></span></p>
                                      </div>
                                      <div class="button">
                                          <button class="menu_item_btn" @click="sendWok(restaurant)">ПОЕСТЬ</button>
                                      </div>

                                  </div>
                              </div>
                          </div>
                          <h4 v-if="Object.keys(readyWok).length">Готовые блюда</h4>
                          <div v-if="Object.keys(readyWok).length" class="slider_wok_2">
                              <div class="item_wok slick-slide" v-for="(product, index) in readyWok" :key="index">
                                  <div class="item_img_wok">
                                      <img :src="product.photo" alt="lanches_slider_1">
                                      <div class="overlay">
                                          <p>{{product.desc}}</p>
                                      </div>
                                  </div>
                                  <div class="item_price_wok">
                                      <div class="item_header">
                                          <div class="title">
                                              <h3>{{product.name}}</h3>
                                          </div>
                                          <div class="town">
                                              <p>{{product.restaurant_name}}</p>
                                          </div>
                                      </div>
                                      <div class="wok_price">
                                          <p>{{product.price}}<span>/{{product.weight}} {{product.weight_type}}</span></p>
                                      </div>
                                      <div class="button">
                                          <button class="menu_item_btn" @click="putInBasket(product.id)">ПОЕСТЬ</button>
                                      </div>

                                  </div>
                              </div>
                          </div>

                      </div>
                      <h3 class="rest_item_title">
                          {{category.name}}
                      </h3>
                      <div class="restrunt_menu_wrapper">
                          <div :class="basket.amount && parseInt(basket.amount) !==0?'menu_container':'menu_container empty'">
                              <div class="sorting_block">

                                  <div class="amount_of_dish">

                                  </div>

                                  <div class="buttons_wrapper">

                                      <button @click="view = 'square'" type="button" :class="view==='square'?'menu_item_btn list_active':'menu_item_btn'">
                                          <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/main/square.svg" alt="">
                                          Плиткой
                                      </button>

                                      <button @click="view = 'list'" type="button" :class="view==='list'?'menu_item_btn list_active':'menu_item_btn'">
                                          <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/main/list.svg" alt="">
                                          Списком
                                      </button>

                                  </div>
                              </div>

                              <div v-if="view === 'list'" class="list_view">
                                  <div class="dishes_list">
                                      <div :class="index%2?'dish bg_color':'dish'" v-for="(product, index) in products.standart" v-if="product.show && (product.category !== 15 && Object.values(product.additives).join(',') !== '67')" :key="product.id">
                                          <div class="dish_name">
                                              <h3>{{product.name}}</h3>
                                              <h4>{{product.restaurant_name}}</h4>
                                              <div class="item">
                                                  <div class="title">
                                                      <h4>{{product.name}}</h4>
                                                      <!-- a href="#" v-if="product.stocks" class="stock">Акция</a-->
                                                  </div>
                                                  <div class="main_description">
                                                      <img :src="product.photo" :alt="product.name">
                                                      <div class="link_row">
                                                          <router-link :to="'/restaurant/' + product.restaurant_id" class="rest_name">{{product.restaurant_name}}</router-link>
                                                          <p class="delivery_time">{{product.delivery_time}} мин</p>
                                                      </div>
                                                  </div>
                                                  <div class="text_row">
                                                      <p>{{product.desc}}</p>
                                                  </div>
                                                  <div class="prise_row">
                                                      <p><strong>{{product.price}}</strong> / {{product.weight}} {{product.weight_type}}</p>
                                                      <button class="menu_item_btn" @click="putInBasket(product.id)">Поесть</button>
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="dish_middle">
                                              <span class="price">{{product.price}} </span>
                                              <span class="weight">/{{product.weight}} {{product.weight_type}}</span>
                                          </div>
                                          <button type="button" class="menu_item_btn" @click="putInBasket(product.id)">Поесть</button>
                                      </div>
                                  </div>
                              </div>

                              <div v-if="view === 'square'" class="square_view">
                                  <div class="items_group">
                                      <slot v-for="product in products.standart">
                                          <item-block  v-if="product.show && (product.category !== 15 && Object.values(product.additives).join(',') !== '67')" :key="product.id" :product.sync="product" :basket.sync="basket"></item-block>
                                      </slot>
                                  </div>
                              </div>
                              <!-------Show more(button)----------->

                          </div>
                          <cart-sidebar :basket.sync="basket" :auth.sync="auth"></cart-sidebar>
                      </div>
                  </div>
                <div class="rest_item_wrapper" v-else>
                      <h3 class="rest_item_title">
                          {{category.name}}
                      </h3>
                      <div class="restrunt_menu_wrapper">
                        <div :class="basket.amount && parseInt(basket.amount) !==0?'menu_container':'menu_container empty'">
                          <div class="sorting_block">

                            <button class="menu_item_btn more" v-if="showRest" @click="showMore">У вас в корзине добавлен ресторан, мы скрыли из поиска другие рестораны, показать?</button>
                            <div class="amount_of_dish">

                            </div>

                            <div class="buttons_wrapper">

                              <button @click="view = 'square'" type="button" :class="view==='square'?'menu_item_btn list_active':'menu_item_btn'">
                                <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/main/square.svg" alt="">
                                Плиткой
                              </button>

                              <button @click="view = 'list'" type="button" :class="view==='list'?'menu_item_btn list_active':'menu_item_btn'">
                                <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/main/list.svg" alt="">
                                Списком
                              </button>

                            </div>
                          </div>
                          <div v-if="view === 'list'" class="list_view">
                            <div class="dishes_list">
                              <div :class="index%2?'dish bg_color':'dish'" v-for="(product, index) in products" v-if="product.show && (product.category !== 15 && Object.values(product.additives).join(',') !== '67')" :key="product.id">
                                <div class="dish_name">
                                  <h3>{{product.name}}</h3>
                                  <h4>{{product.restaurant_name}}</h4>
                                  <div class="item">
                                    <div class="title">
                                      <h4>{{product.name}}</h4>
                                      <!-- a href="#" v-if="product.stocks" class="stock">Акция</a-->
                                    </div>
                                    <div class="main_description">
                                      <img :src="product.photo" :alt="product.name">
                                      <div class="link_row">
                                        <router-link :to="'/restaurant/' + product.restaurant_id" class="rest_name">{{product.restaurant_name}}</router-link>
                                        <p class="delivery_time">{{product.delivery_time}} мин</p>
                                      </div>
                                    </div>
                                    <div class="text_row">
                                      <p>{{product.desc}}</p>
                                    </div>
                                    <div class="prise_row">
                                      <p><strong>{{product.price}}</strong> / {{product.weight}} {{product.weight_type}}</p>
                                      <button class="menu_item_btn" @click="putInBasket(product.id)">Поесть</button>
                                    </div>
                                  </div>
                                </div>
                                <div class="dish_middle">
                                  <span class="price">{{product.price}} </span>
                                  <span class="weight">/{{product.weight}} {{product.weight_type}}</span>
                                </div>
                                <button type="button" class="menu_item_btn" @click="putInBasket(product.id)">Поесть</button>
                              </div>
                            </div>
                          </div>
                          <div v-if="view === 'square'" class="square_view">
                            <div class="items_group">
                                <slot v-for="product in products">
                                    <item-block v-if="product.show && (product.category !== 15 && Object.values(product.additives).join(',') !== '67')" :key="product.id" :product.sync="product" :basket.sync="basket"></item-block>
                                    <div :key="'advF'+product.id" v-if="category.adv&&getKeyByValue(showProducts, product.id) === 1" class="restaurant_bonus_line" v-html="typeof category.adv === 'string'?category.adv:showAdvMethod()">
                                    </div>
                                </slot>
                            </div>
                          </div>
                          <!-------Show more(button)----------->
                        </div>
                        <cart-sidebar :basket.sync="basket" :auth.sync="auth"></cart-sidebar>
                      </div>
                  </div>
              </div>
            </div>
        </section>
        <section class="section_b">
          <div class="container">
            <div class="title">
              <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/main/big_van_24.svg" alt="big_van_24">
              <h1>Круглосуточная доставка еды</h1>
            </div>
            <seoProduct v-if="category.id" :city.sync="city" :category.sync="category" />
          </div>
        </section>
    </main>

</template>

<script>
import Vue from 'vue'
import axios from '@/router/http'
import cartSidebar from '@/components/cartSidebar'
import seoProduct from '@/components/seoProduct'
import itemBlock from '@/components/item'
import countdown from '@chenfengyuan/vue-countdown'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel'
import $ from 'jquery'
import 'bootstrap-datepicker'
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.ru.min'
import moment from 'moment'
export default {
  name: 'product',
  props: ['city', 'auth', 'basket', 'geo'],
  components: {cartSidebar, seoProduct, itemBlock, countdown},
  data () {
    return {
      products: {},
      categories: [],
      category: {id: null, name: null, desc: null},
      priceMin: null,
      priceMax: null,
      step: null,
      price: 0,
      itemLimit: 30,
      title: '',
      filterWrap: 0,
      view: 'square',
      methods: [],
      kitchens: [],
      orderRestaurant: null,
      orderType: null,
      countPersons: 1,
      countDays: 1,
      days: [],
      currentCake: null,
      selectCake: null,
      selectFill: null,
      priceCake: 0,
      layers: 1,
      floors: 1,
      weight: 1,
      photos: [],
      comments: null,
      selectProgram: null,
      currentProgram: null,
      selectCategory: null,
      ingredients: {},
      main: {id: null, name: null},
      size: {id: null, name: null},
      pizza: {},
      readyPizza: {},
      wok: {},
      readyWok: {},
      showRest: null,
      additives_temp: {},
      ingredients_temp: {},
      showAdv: [],
      showProducts: [],
      filter: {
        categories: {},
        additives: {},
        ingredients: {},
        methods: {}
      },
      selectedLunch: {}
    }
  },
  metaInfo () {
    return {
      title: ' - ' + this.category.name,
      meta: [
        { vmid: 'description', name: 'description', property: 'description', content: this.category.desc }
      ]
    }
  },
  created () {
    if (this.auth.uid) this.initPage()
    else {
      let interval = setInterval(() => {
        if (this.auth.uid) {
          clearInterval(interval)
          this.initPage()
        }
      }, 100)
    }
    this.checkPosition()
    $(document).scroll(() => {
      this.checkPosition()
    })
    $(window).resize(() => {
      this.checkPosition()
    })
  },
  mounted () {
    let $this = this
    $('#restaurant_toggle').on('click', function () {
      $('#restaurant_crytery_inner').toggleClass('active')
      $('.choice_toggle').toggleClass('active')
    })

    $('#min_amount_range').on('input', function () {
      $this.price = $(this).val()
      $this.reshow()
    })
    $('#min_amount_range_2').on('input', function () {
      $this.price = $(this).val()
      $this.reshow()
    })
  },
  watch: {
    size (val) {
      this.rebuildPizza()
    },
    main (val) {
      $('.osnova_btn.menu_item_btn').removeClass('active')
      if (val) $('[data-main="' + val + '"]').addClass('active')
      if (this.category.id === 2) this.rebuildPizza()
      else this.rebuildWok()
    },
    selectFill (val) {
      if (val) {
        this.priceCake = parseFloat(this.currentCake.price) + parseFloat(val.price)
      } else if (this.currentCake) this.priceCake = parseFloat(this.currentCake.price)
      else this.priceCake = 0
    },
    currentCake (val) {
      if (val) {
        this.priceCake = parseFloat(val.price)
        setTimeout(() => {
          $('.pou_up_cake_slider').slick({
            dots: false,
            nav: false,
            infinite: true,
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 1,
            swipeToSlide: true,
            responsive: [
              {
                breakpoint: 968,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  infinite: true,
                  dots: true
                }
              },
              {
                breakpoint: 576,
                settings: {
                  slidesToShow: 1,
                  infinite: true,
                  dots: true,
                  slidesToScroll: 1
                }
              }
            ]
          })
        }, 100)
      }
    },
    countDays (val) {
      if (val <= 0) this.countDays = 1
    },
    countPersons (val) {
      if (val <= 0) this.countPersons = 1
    },
    layers (val) {
      if (val <= 0) this.layers = 1
    },
    floors (val) {
      if (val <= 0) this.floors = 1
    },
    weight (val) {
      if (val <= 0) this.weight = 1
      else {
        if (this.selectFill) {
          this.priceCake = parseFloat(this.currentCake.price) + parseFloat(this.selectFill.price)
        } else if (this.currentCake) this.priceCake = parseFloat(this.currentCake.price)
        else this.priceCake = 0
        this.priceCake = this.priceCake * this.weight
      }
    },
    $route (to, from) {
      var id = to.params.id
      axios.get('https://lk.when-hungry.com/mobile/category-get?id=' + id + '&uid=' + this.auth.uid).then(response => {
        this.category = response.data.category
        this.categories = response.data.kitchens
        this.methods = response.data.methods
        this.itemLimit = 30
        this.reshow()
      })
    },
    'price' (val) {
      this.reshow()
    },
    'view' (val, oldVal) {
      if (val && val !== oldVal) {
        this.itemLimit = 30
        this.reshow()
      }
    },
    filter: {
      handler (newVal, oldVal) {
        this.reshow()
      },
      deep: true
    },
    basket: {
      handler (newVal, oldVal) {
        if (Object.keys(this.basket.basket).length === 1) {
          this.showRest = Object.keys(this.basket.basket)[0]
        } else
        if (Object.keys(this.basket.basket).length === 0) {
          this.showRest = null
        }
      },
      deep: true
    },
    'category.name' (val) {
      this.title = val
    },
    'auth.city' (val) {
      this.initAjax()
    },
    'auth.setNewAdr' (val) {
      this.initAjax()
    },
    'category.id' (val, old) {
      this.filter = {
        categories: {},
        additives: {},
        ingredients: {},
        methods: {}
      }
      this.filter.categories[val] = val
      this.initAjax()
      this.$root.cat = {img: this.category.photo, title: this.category.desc ? this.category.desc : this.category.name}
    },
    orderRestaurant (val) {
      if (val) {
        if (this.selectedLunch[this.orderType] && this.selectedLunch[this.orderType][val]) {
          if (this.orderType === 'standart' || this.orderType === 'lunch') {
            this.goOrder()
            setTimeout(() => {
              $('.bootstrap_calendar').datepicker({
                multidate: true,
                minViewMode: 0,
                maxViewMode: 0,
                weekStart: 1,
                language: 'ru',
                format: 'dd-mm-yyyy',
                startDate: 'now'
              }).on('changeDate', () => {
                this.days = []
                $.each($('.bootstrap_calendar').datepicker('getDates'), (key, val) => {
                  this.days.push(moment(val).format('DD.MM.YYYY'))
                })
              })
            }, 300)
          }
        } else {
          this.orderRestaurant = null
          this.orderType = null
          alert('Вы ничего не выбрали для заказа')
        }
      }
    },
    showRest (val) {
      this.reshow()
    }
  },
  methods: {
    randomInteger (min, max) {
      // получить случайное число от (min-0.5) до (max+0.5)
      let rand = min - 0.5 + Math.random() * (max - min + 1)
      return Math.round(rand)
    },
    showAdvMethod () {
      return this.category.adv[this.randomInteger(1, this.category.adv.length) - 1]
    },
    getKeyByValue (object, value) {
      let show = 0
      let count = (parseInt(Object.keys(object).find(key => object[key] === value)) + 1)
      if (count % 9 === 0) {
        show = 1
        /*
        if (this.basket.amount && parseInt(this.basket.amount) !== 0) {
          if (Number.isInteger((count + this.showAdv.length) / 2)) {
            show = 2
          }
        } else {
          if (Number.isInteger((count + this.showAdv.length) / 3)) {
            show = 2
          }
        }
        */
        if (show === 1 && this.showAdv.indexOf(value) === -1) {
          this.showAdv.push(value)
        }
      }
      return show
    },
    showModal (val) {
      this.$root.modals = val
    },
    showMore () {
      this.showRest = null
    },
    initPage () {
      var id = this.$route.params.id
      axios.get('https://lk.when-hungry.com/mobile/category-get?id=' + id + '&uid=' + this.auth.uid).then(response => {
        this.category = response.data.category
        this.categories = response.data.kitchens
        this.methods = response.data.methods
      })
    },
    initAjax () {
      let val = this.category.id
      if (val !== 2 && val !== 33 && val !== 9 && val !== 29 && val !== 21 && val !== 30 && val !== 15) {
        this.filter.categories[val] = val
        axios.get('https://lk.when-hungry.com/mobile/products-get?type=category&id=' + this.$route.params.id + '&uid=' + this.auth.uid).then(response => {
          this.products = response.data.products
          this.priceMax = response.data.max
          this.priceMin = response.data.min
          this.price = response.data.max
          this.additives_temp = response.data.additives_temp
          this.ingredients_temp = response.data.ingredients_temp
          this.reshow()
        })
      } else if ((val === 9 || val === 30)) {
        axios.get('https://lk.when-hungry.com/mobile/products-get?type=lunch&id=' + this.$route.params.id + '&uid=' + this.auth.uid).then(response => {
          this.products = response.data.products
          this.priceMax = response.data.max
          this.priceMin = response.data.min
          this.step = response.data.step
          this.price = response.data.max
          this.kitchens = response.data.kitchens
          this.reshow()
        })
      } else if ((val === 2)) {
        axios.get('https://lk.when-hungry.com/mobile/products-get?type=pizza&id=' + this.$route.params.id + '&uid=' + this.auth.uid).then(response => {
          this.products = response.data.products
          this.priceMax = response.data.max
          this.priceMin = response.data.min
          this.step = response.data.step
          this.price = response.data.max
          this.kitchens = response.data.kitchens
          this.additives_temp = response.data.additives_temp
          this.ingredients_temp = response.data.ingredients_temp
          this.reshow()

          $('#constructor_toggle').on('click', function () {
            $('#constructor_toggle').toggleClass('active')
            $('.create_wok').toggleClass('active')
          })
        })
      } else if ((val === 33)) {
        axios.get('https://lk.when-hungry.com/mobile/products-get?type=wok&id=' + this.$route.params.id + '&uid=' + this.auth.uid).then(response => {
          this.products = response.data.products
          this.priceMax = response.data.max
          this.priceMin = response.data.min
          this.step = response.data.step
          this.price = response.data.max
          this.kitchens = response.data.kitchens
          this.additives_temp = response.data.additives_temp
          this.ingredients_temp = response.data.ingredients_temp
          this.reshow()

          $('#constructor_toggle').on('click', function () {
            $('#constructor_toggle').toggleClass('active')
            $('.create_wok').toggleClass('active')
          })
        })
      } else if (val === 29) {
        axios.get('https://lk.when-hungry.com/mobile/products-get?type=subs&id=' + this.$route.params.id + '&uid=' + this.auth.uid).then(response => {
          this.products = response.data.products
          this.priceMax = response.data.max
          this.priceMin = response.data.min
          this.step = response.data.step
          this.price = response.data.max
          this.kitchens = response.data.kitchens
          this.reshow()
        })
      } else if (val === 21) {
        axios.get('https://lk.when-hungry.com/mobile/products-get?type=health&id=' + this.$route.params.id + '&uid=' + this.auth.uid).then(response => {
          this.products = response.data.products
          this.priceMax = response.data.max
          this.priceMin = response.data.min
          this.step = response.data.step
          this.price = response.data.max
          this.kitchens = response.data.kitchens
          this.reshow()
        })
      } else if (val === 15) {
        axios.get('https://lk.when-hungry.com/mobile/products-get?type=cake&id=' + this.$route.params.id + '&uid=' + this.auth.uid).then(response => {
          this.products = response.data.products
          this.priceMax = response.data.max
          this.priceMin = response.data.min
          this.step = response.data.step
          this.price = response.data.max
          this.kitchens = response.data.kitchens
          this.reshow()
        })
      }
    },
    rebuildPizza () {
      this.pizza = {}
      this.readyPizza = {}
      $('.slider_wok').slick('unslick')
      $('.slider_wok_2').slick('unslick')
      $.each(this.products.pizzaSize, (rId, restaurant) => {
        $.each(restaurant.products, (pId, product) => {
          if (parseInt(product.param1) === this.main.id && parseInt(product.param2) === this.size.id) {
            if (this.pizza[restaurant.id] === undefined) {
              this.pizza[restaurant.id] = {
                id: restaurant.id,
                name: restaurant.name,
                desc: restaurant.desc,
                img: restaurant.img,
                amount: 0,
                products: {},
                productId: product.id
              }
            }
            if (this.pizza[restaurant.id].products[product.id] === undefined) this.pizza[restaurant.id].products[product.id] = {}
            this.pizza[restaurant.id].products[product.id] = parseFloat(product.price)
          }
        })
      })
      $.each(this.products.pizzaIng, (rId, restaurant) => {
        $.each(restaurant.products, (pId, product) => {
          if (this.ingredients[parseInt(product.param2)] && this.ingredients[parseInt(product.param2)].count) {
            if (this.pizza[restaurant.id] === undefined) {
              this.pizza[restaurant.id] = {
                id: restaurant.id,
                name: restaurant.name,
                desc: restaurant.desc,
                img: restaurant.img,
                amount: 0,
                products: {}
              }
            }
            if (this.pizza[restaurant.id].products[product.id] === undefined) this.pizza[restaurant.id].products[product.id] = {}
            this.pizza[restaurant.id].products[product.id] = parseFloat(product.price) * parseInt(this.ingredients[parseInt(product.param2)].count)
          }
        })
      })
      $.each(this.pizza, (rId, restaurant) => {
        if (Object.keys(restaurant.products).length === Object.keys(this.ingredients).length + 1) {
          $.each(restaurant.products, (k, v) => {
            restaurant.amount += parseFloat(v) || 0
          })
        } else delete this.pizza[rId]
      })
      if (Object.keys(this.pizza).length) {
        setTimeout(() => {
          $('.slider_wok').slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 1,
            adaptiveHeight: true,
            swipeToSlide: true,
            responsive: [
              {
                breakpoint: 968,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  infinite: true,
                  arrow: false,
                  dots: true
                }
              },
              {
                breakpoint: 576,
                settings: {
                  slidesToShow: 1,
                  infinite: true,
                  dots: true,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 330,
                settings: {
                  slidesToShow: 1,
                  infinite: true,
                  dots: true,
                  slidesToScroll: 1
                }
              }
            ]
          })
        }, 1)
      }
      if (Object.keys(this.ingredients).length) {
        $.each(this.products.standart, (rId, product) => {
          let count = 0
          $.each(this.ingredients, (iI, p) => {
            if ($.inArray(iI, Object.keys(product.ingredients)) !== -1) count++
          })
          if (count === Object.keys(this.ingredients).length && Object.keys(this.readyPizza).length < 15) {
            this.readyPizza[product.id] = product
          }
        })
        if (Object.keys(this.readyPizza).length) {
          setTimeout(() => {
            $('.slider_wok_2').slick({
              dots: false,
              infinite: true,
              speed: 300,
              slidesToShow: 2,
              adaptiveHeight: true,
              slidesToScroll: 1,
              swipeToSlide: true,
              responsive: [
                {
                  breakpoint: 968,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                  }
                },
                {
                  breakpoint: 576,
                  settings: {
                    slidesToShow: 1,
                    infinite: true,
                    dots: true,
                    slidesToScroll: 1
                  }
                }
              ]
            })
          }, 1)
        }
      }
    },
    rebuildWok () {
      this.wok = {}
      this.readyWok = {}
      $('.slider_wok').slick('unslick')
      $('.slider_wok_2').slick('unslick')
      $.each(this.products.wokSize, (rId, restaurant) => {
        $.each(restaurant.products, (pId, product) => {
          if (parseInt(product.param1) === this.main.id) {
            if (this.wok[restaurant.id] === undefined) {
              this.wok[restaurant.id] = {
                id: restaurant.id,
                name: restaurant.name,
                desc: restaurant.desc,
                img: restaurant.img,
                amount: 0,
                products: {},
                productId: product.id
              }
            }
            if (this.wok[restaurant.id].products[product.id] === undefined) this.wok[restaurant.id].products[product.id] = {}
            this.wok[restaurant.id].products[product.id] = parseFloat(product.price)
          }
        })
      })
      $.each(this.products.wokIng, (rId, restaurant) => {
        $.each(restaurant.products, (pId, product) => {
          if (this.ingredients[parseInt(product.param2)] && this.ingredients[parseInt(product.param2)].count) {
            if (this.wok[restaurant.id] === undefined) {
              this.wok[restaurant.id] = {
                id: restaurant.id,
                name: restaurant.name,
                desc: restaurant.desc,
                img: restaurant.img,
                amount: 0,
                products: {}
              }
            }
            if (this.wok[restaurant.id].products[product.id] === undefined) this.wok[restaurant.id].products[product.id] = {}
            this.wok[restaurant.id].products[product.id] = parseFloat(product.price) * parseInt(this.ingredients[parseInt(product.param2)].count)
          }
        })
      })
      $.each(this.wok, (rId, restaurant) => {
        if (Object.keys(restaurant.products).length === Object.keys(this.ingredients).length + 1) {
          $.each(restaurant.products, (k, v) => {
            restaurant.amount += parseFloat(v) || 0
          })
        } else delete this.wok[rId]
      })
      if (Object.keys(this.wok).length) {
        setTimeout(() => {
          $('.slider_wok').slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            adaptiveHeight: true,
            swipeToSlide: true,
            responsive: [
              {
                breakpoint: 968,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 1,
                  infinite: true,
                  arrow: false,
                  dots: true
                }
              },
              {
                breakpoint: 576,
                settings: {
                  slidesToShow: 2,
                  infinite: true,
                  dots: true,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 330,
                settings: {
                  slidesToShow: 1,
                  infinite: true,
                  dots: true,
                  slidesToScroll: 1
                }
              }
            ]
          })
        }, 1)
      }
      if (Object.keys(this.ingredients).length) {
        $.each(this.products.standart, (rId, product) => {
          let count = 0
          if (product.ingredients[this.main.id]) count++
          $.each(this.ingredients, (iI, p) => {
            if ($.inArray(iI, Object.keys(product.ingredients)) !== -1) count++
          })
          if (count === (Object.keys(this.ingredients).length + 1) && Object.keys(this.readyWok).length < 15) {
            this.readyWok[product.id] = product
          }
        })
        if (Object.keys(this.readyWok).length) {
          setTimeout(() => {
            $('.slider_wok_2').slick({
              dots: false,
              infinite: true,
              speed: 300,
              slidesToShow: 3,
              adaptiveHeight: true,
              slidesToScroll: 1,
              swipeToSlide: true,
              responsive: [
                {
                  breakpoint: 968,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                  }
                },
                {
                  breakpoint: 576,
                  settings: {
                    slidesToShow: 2,
                    infinite: true,
                    dots: true,
                    slidesToScroll: 1
                  }
                }
              ]
            })
          }, 1)
        }
      }
    },
    mIng (index, name) {
      if (this.ingredients[index]) this.ingredients[index].count--
      else this.ingredients[index] = {name: name, count: 0}
      $('[data-ingredient="' + index + '"]').text(this.ingredients[index].count)
      if (this.ingredients[index].count === 0) delete this.ingredients[index]
      if (this.category.id === 2) this.rebuildPizza()
      else this.rebuildWok()
    },
    pIng (index, name) {
      if (this.ingredients[index]) this.ingredients[index].count++
      else this.ingredients[index] = {name: name, count: 1}
      $('[data-ingredient="' + index + '"]').text(this.ingredients[index].count)

      if (this.ingredients[index].count === 0) delete this.ingredients[index]
      if (this.category.id === 2) this.rebuildPizza()
      else this.rebuildWok()
    },
    deletePhoto (file) {
      this.photos.splice(this.photos.indexOf(file), 1)
    },
    handleFileUploads () {
      this.files = this.$refs.files.files
      for (var i = 0; i < this.files.length; i++) {
        let file = this.files[i]
        var reader = new FileReader()
        reader.onload = (e) => {
          this.photos.push({name: file.name, data: e.target.result})
        }
        reader.readAsDataURL(file)
      }
    },
    selectsCake (restaurant) {
      if (this.selectCake != null) {
        this.currentCake = this.products.cake[restaurant].products[this.selectCake]
      } else alert('Вы ничего не выбрали')
    },
    selectsProgram (restaurant) {
      if (this.selectProgram != null) {
        this.currentProgram = this.products.program[restaurant].products[this.selectProgram]
      } else alert('Вы ничего не выбрали')
    },
    selectLunch (type, restaurant, product, price) {
      if (this.selectedLunch[type] === undefined) this.selectedLunch[type] = {}
      if (this.selectedLunch[type][restaurant] === undefined) this.selectedLunch[type][restaurant] = {}
      if (this.selectedLunch[type][restaurant][product] === undefined) {
        this.selectedLunch[type][restaurant][product] = parseInt(price)
        $('[data-product="' + product + '"]').addClass('active')
      } else {
        delete this.selectedLunch[type][restaurant][product]
        $('[data-product="' + product + '"]').removeClass('active')
      }
      // function for adding two numbers. Easy!
      const add = (a, b) =>
        a + b// use reduce to sum our array
      if (Object.values(this.selectedLunch[type][restaurant]).length !== 0) this.products[type][restaurant].amount = Object.values(this.selectedLunch[type][restaurant]).reduce(add)
      else this.products[type][restaurant].amount = 0
    },
    deleteLunch (type, restaurant) {
      if (this.selectedLunch[type] === undefined) this.selectedLunch[type] = {}
      else {
        if (this.selectedLunch[type][restaurant] === undefined) this.selectedLunch[type][restaurant] = {}
        else this.selectedLunch[type][restaurant] = {}
      }
      $('[data-restaurant="' + restaurant + '"]').removeClass('active')
    },
    checkPosition () {
      let element
      if ($('.restrunt_menu_wrapper .item').length !== 0) element = $('.restrunt_menu_wrapper .item').eq(-3)
      if ($('.restrunt_menu_wrapper .dish').length !== 0) element = $('.restrunt_menu_wrapper .dish').eq(-20)
      if (element !== undefined && element.length !== 0) {
        var divPosition = element.offset()
        var divTop = divPosition.top
        var divLeft = divPosition.left
        var divWidth = element.width()
        var divHeight = element.height()
        var topScroll = $(document).scrollTop()
        var leftScroll = $(document).scrollLeft()
        var screenWidth = $(window).width()
        var screenHeight = $(window).height()
        var seeX1 = leftScroll
        var seeX2 = screenWidth + leftScroll
        var seeY1 = topScroll
        var seeY2 = screenHeight + topScroll
        var divX1 = divLeft
        var divX2 = divLeft + divHeight
        var divY1 = divTop
        var divY2 = divTop + divWidth
        if (divX1 >= seeX1 && divX2 <= seeX2 && divY1 >= seeY1 && divY2 <= seeY2) {
          this.itemLimit += 10
          this.reshow()
        }
      }
    },
    isMobile () {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    reshow () {
      if (!this.setInitReshow) {
        this.setInitReshow = 1
        if (this.category.id !== 9 && this.category.id !== 2 && this.category.id !== 33 && this.category.id !== 29 && this.category.id !== 21 && this.category.id !== 30 && this.category.id !== 15) {
          this.showProducts = []
          this.showAdv = []
          let categories = this.filter.categories
          let additives = this.filter.additives
          let ingredients = this.filter.ingredients
          let methods = this.filter.methods
          $.each(categories, (k, v) => {
            if (v === false) Vue.delete(categories, k)
          })
          $.each(additives, (k, v) => {
            if (v === false) {
              Vue.delete(additives, k)
              $.each(this.categories[this.category.id].additives[k].ingredients, (kk, vv) => {
                Vue.delete(ingredients, kk)
              })
            }
          })
          $.each(ingredients, (k, v) => {
            if (v === false) Vue.delete(ingredients, k)
          })
          $.each(methods, (k, v) => {
            if (v === false) Vue.delete(methods, k)
          })
          let count = 0
          for (let productId in this.products) {
            let sc = 0
            let sa = 0
            let si = 0
            let sm = 0
            let saa = 0
            if (Object.keys(categories).length) {
              $.each(categories, (k, v) => {
                if ($.inArray(parseInt(k), this.products[productId].categorys_id) !== -1) sc = 1
              })
            } else sc = 1

            if (Object.keys(additives).length) {
              $.each(additives, (k, v) => {
                if ($.inArray(k, Object.keys(this.products[productId].additives)) !== -1) sa = 1
              })
            } else sa = 1

            if (Object.keys(ingredients).length) {
              $.each(ingredients, (k, v) => {
                if ($.inArray(k, Object.keys(this.products[productId].ingredients)) !== -1) si = 1
              })
            } else si = 1

            if (Object.keys(methods).length) {
              $.each(methods, (k, v) => {
                if ($.inArray(k, Object.keys(this.products[productId].methods)) !== -1) sm = 1
              })
            } else sm = 1
            if (parseInt(this.products[productId].price) <= this.price) saa = 1
            if (sc === 1 && sa === 1 && si === 1 && saa === 1 && sm === 1 && count <= this.itemLimit && (!this.showRest || this.products[productId].restaurant_id === parseInt(this.showRest))) {
              this.products[productId].show = 1
              this.showProducts.push(this.products[productId].id)
              count++
            } else this.products[productId].show = 0
          }
        } else if (this.category.id === 2 || this.category.id === 33) {
          let categories = this.filter.categories
          let additives = this.filter.additives
          let ingredients = this.filter.ingredients
          let methods = this.filter.methods
          $.each(categories, (k, v) => {
            if (v === false) Vue.delete(categories, k)
          })
          $.each(additives, (k, v) => {
            if (v === false) {
              Vue.delete(additives, k)
              $.each(this.categories[this.category.id].additives[k].ingredients, (kk, vv) => {
                Vue.delete(ingredients, kk)
              })
            }
          })
          $.each(ingredients, (k, v) => {
            if (v === false) Vue.delete(ingredients, k)
          })
          $.each(methods, (k, v) => {
            if (v === false) Vue.delete(methods, k)
          })
          let count = 0
          for (let productId in this.products.standart) {
            let sc = 0
            let sa = 0
            let si = 0
            let sm = 0
            let saa = 0
            if (Object.keys(categories).length) {
              $.each(categories, (k, v) => {
                if ($.inArray(parseInt(k), this.products.standart[productId].categorys_id) !== -1) sc = 1
              })
            } else sc = 1

            if (Object.keys(additives).length) {
              $.each(additives, (k, v) => {
                if ($.inArray(k, Object.keys(this.products.standart[productId].additives)) !== -1) sa = 1
              })
            } else sa = 1

            if (Object.keys(ingredients).length) {
              $.each(ingredients, (k, v) => {
                if ($.inArray(k, Object.keys(this.products.standart[productId].ingredients)) !== -1) si = 1
              })
            } else si = 1

            if (Object.keys(methods).length) {
              $.each(methods, (k, v) => {
                if ($.inArray(k, Object.keys(this.products.standart[productId].methods)) !== -1) sm = 1
              })
            } else sm = 1
            if (parseInt(this.products.standart[productId].price) <= this.price) saa = 1
            if (sc === 1 && sa === 1 && si === 1 && saa === 1 && sm === 1 && count <= this.itemLimit) {
              this.products.standart[productId].show = 1
              count++
            } else this.products.standart[productId].show = 0
          }
        } else {
          let categories = this.filter.categories
          let methods = this.filter.methods
          $.each(categories, (k, v) => {
            if (v === false) Vue.delete(categories, k)
          })
          $.each(methods, (k, v) => {
            if (v === false) Vue.delete(methods, k)
          })
          for (let type in this.products) {
            for (let restaurantId in this.products[type]) {
              let sc = 0
              let sm = 0
              let saa = 0
              if (Object.keys(categories).length) {
                $.each(categories, (k, v) => {
                  // if ($.inArray(k, Object.keys(this.products[type][restaurantId].categories)) !== -1) sc = 1
                  sc = 1
                })
              } else sc = 1

              if (Object.keys(methods).length) {
                $.each(methods, (k, v) => {
                  if ($.inArray(k, Object.keys(this.products[type][restaurantId].methods)) !== -1) sm = 1
                })
              } else sm = 1
              if (parseInt(this.products[type][restaurantId].minimal_amount) <= this.price) saa = 1
              if (sc === 1 && sm === 1 && saa === 1) this.products[type][restaurantId].show = 1; else this.products[type][restaurantId].show = 0
            }
          }
          setTimeout(() => {
            $('.order_lunch_row_slider:not(.slick-initialized)').slick({
              dots: false,
              speed: 300,
              swipeToSlide: true,
              slidesToShow: 3,
              slidesToScroll: 1,
              lazyLoad: 'ondemand',
              responsive: [
                {
                  breakpoint: 1169,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: false
                  }
                },
                {
                  breakpoint: 576,
                  settings: {
                    slidesToShow: 1,
                    arrows: false,
                    dots: false,
                    slidesToScroll: 1
                  }
                }
              ]
            })
          }, 300)
        }
        this.setInitReshow = 0
      }
    },
    putInBasket (id) {
      if (this.geo.address && this.geo.lat2 && this.geo.lng2) {
        var formData = new FormData()
        formData.append('id', id)
        formData.append('uid', this.auth.uid)
        axios.post('https://lk.when-hungry.com/mobile/put-in-basket',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(response => {
          this.$root.basketUpdate = 1
        })
      } else this.$root.modals = 'selectCity'
    },
    goOrder () {
      if (this.geo.address && this.geo.lat2 && this.geo.lng2) {
        var formData = new FormData()
        formData.append('restaurant_id', this.orderRestaurant)
        formData.append('ids', Object.keys(this.selectedLunch[this.orderType][this.orderRestaurant]))
        // formData.append('countDays', this.countDays)
        // formData.append('countPersons', this.countPersons)
        // formData.append('days', this.days)
        formData.append('uid', this.auth.uid)
        axios.post('https://lk.when-hungry.com/mobile/add-to-basket',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(response => {
          this.$root.basketUpdate = 1
          if (confirm('Ваш выбор добавлен в корзину\n ОК - перейти в корзину\n Отмена - остаться тут, и заказать еще')) {
            this.$router.push({name: 'cart'})
          }
        })
      } else this.$root.modals = 'selectCity'
    },
    sendPizza (restaurant) {
      if (this.geo.address && this.geo.lat2 && this.geo.lng2) {
        if (!this.main.id) alert('Вам необходимо выбрать основу')
        else if (!this.size.id) alert('Вам необходимо выбрать размер')
        else if (!Object.keys(this.ingredients).length) alert('Вам необходимо добавить хотя бы 1 начинку')
        else {
          var formData = new FormData()
          formData.append('restaurant_id', restaurant.id)
          formData.append('id', restaurant.productId)
          formData.append('amount', restaurant.amount)
          formData.append('desc[]', 'Основа: ' + this.main.name)
          formData.append('desc[]', 'Размер: ' + this.size.name)
          $.each(this.ingredients, (key, val) => {
            formData.append('desc[]', 'Начинка : ' + val.name + ' - ' + val.count + 'шт')
          })
          formData.append('uid', this.auth.uid)
          axios.post('https://lk.when-hungry.com/mobile/add-to-basket-cake',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          ).then(response => {
            this.$root.basketUpdate = 1
            if (confirm('Ваш выбор добавлен в корзину\n ОК - перейти в корзину\n Отмена - остаться тут, и заказать еще')) {
              this.$router.push({name: 'cart'})
            }
          })
        }
      } else this.$root.modals = 'selectCity'
    },
    sendWok (restaurant) {
      if (this.geo.address && this.geo.lat2 && this.geo.lng2) {
        if (!this.main.id) alert('Вам необходимо выбрать основу')
        else if (!Object.keys(this.ingredients).length) alert('Вам необходимо добавить хотя бы 1 начинку')
        else {
          var formData = new FormData()
          formData.append('restaurant_id', restaurant.id)
          formData.append('id', restaurant.productId)
          formData.append('amount', restaurant.amount)
          formData.append('desc[]', 'Основа: ' + this.main.name)
          $.each(this.ingredients, (key, val) => {
            formData.append('desc[]', 'Начинка : ' + val.name + ' - ' + val.count + 'шт')
          })
          formData.append('uid', this.auth.uid)
          axios.post('https://lk.when-hungry.com/mobile/add-to-basket-cake',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          ).then(response => {
            this.$root.basketUpdate = 1
            if (confirm('Ваш выбор добавлен в корзину\n ОК - перейти в корзину\n Отмена - остаться тут, и заказать еще')) {
              this.$router.push({name: 'cart'})
            }
          })
        }
      } else this.$root.modals = 'selectCity'
    },
    sendCake () {
      if (this.geo.address && this.geo.lat2 && this.geo.lng2) {
        if (parseInt(this.currentCake.param1) > parseInt(this.weight)) alert('Вам необходимо заказать как минимум ' + this.currentCake.param1 + 'кг')
        else if (!this.selectFill) alert('Вам необходимо выбрать начинку')
        else {
          var formData = new FormData()
          formData.append('restaurant_id', this.currentCake.restaurant_id)
          formData.append('id', this.currentCake.id)
          formData.append('amount', this.priceCake)
          formData.append('desc[]', 'Начинка: ' + this.selectFill.name)
          formData.append('desc[]', 'Стоимость начинки: ' + this.selectFill.price)
          formData.append('desc[]', 'Стоимость торта за кг: ' + this.currentCake.price)
          formData.append('desc[]', 'Стоимость заказа: ' + this.priceCake)
          formData.append('desc[]', 'Количество ярусов: ' + this.floors)
          formData.append('desc[]', 'Количество слоев: ' + this.layers)
          formData.append('desc[]', 'Желаемый вес (кг): ' + this.weight)
          if (this.comments) formData.append('desc[]', 'Пожелания: ' + this.comments)
          if (this.photos !== null) {
            for (var i = 0; i < this.photos.length; i++) {
              let file = this.photos[i]
              formData.append('photos[' + i + ']', file.data)
            }
          }
          formData.append('uid', this.auth.uid)
          axios.post('https://lk.when-hungry.com/mobile/add-to-basket-cake',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          ).then(response => {
            this.$root.basketUpdate = 1
            if (confirm('Ваш выбор добавлен в корзину\n ОК - перейти в корзину\n Отмена - остаться тут, и заказать еще')) {
              this.$router.push({name: 'cart'})
            }
          })
        }
      } else this.$root.modals = 'selectCity'
    },
    sendHealth () {
      if (this.geo.address && this.geo.lat2 && this.geo.lng2) {
        let prog = null
        for (var ii = 0; ii < Object.keys(this.products.health[this.currentProgram.restaurant_id].products).length; ii++) {
          var product = this.products.health[this.currentProgram.restaurant_id].products[ii]
          if (product.param1.split(',').includes(this.currentProgram.param1) && product.param2.split(',').includes(this.currentProgram.param2) && product.param3.split(',').includes(this.currentProgram.id.toString())) prog = product
        }
        if (!prog) alert('В выбранном вами дне нет ни одного предложения')
        else {
          var formData = new FormData()
          formData.append('restaurant_id', this.currentProgram.restaurant_id)
          formData.append('id', this.currentProgram.id)
          formData.append('desc[]', 'Неделя: ' + this.currentProgram.param1)
          formData.append('desc[]', 'День: ' + this.currentProgram.param2)
          formData.append('desc[]', 'Название: ' + product.name)
          formData.append('desc[]', 'Описание: ' + product.desc)
          formData.append('uid', this.auth.uid)
          axios.post('https://lk.when-hungry.com/mobile/add-to-basket-cake',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          ).then(response => {
            this.$root.basketUpdate = 1
            if (confirm('Ваш выбор добавлен в корзину\n ОК - перейти в корзину\n Отмена - остаться тут, и заказать еще')) {
              this.$router.push({name: 'cart'})
            }
          })
        }
      } else this.$root.modals = 'selectCity'
    },
    plusBasket (id) {
      var formData = new FormData()
      formData.append('id', id)
      formData.append('uid', this.auth.uid)
      axios.post('https://lk.when-hungry.com/mobile/plus-in-basket',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        this.$root.basketUpdate = 1
      })
    },
    minusBasket (id) {
      var formData = new FormData()
      formData.append('id', id)
      formData.append('uid', this.auth.uid)
      axios.post('https://lk.when-hungry.com/mobile/minus-in-basket',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        this.$root.basketUpdate = 1
      })
    },
    changeCategory (id) {
      this.$router.push({name: 'product', params: {id: id}})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/product.vue